import { useEffect, useState, useRef } from "react";
import { isClientSideRendering } from "../helpers/rendererType";

export function useIsInView(isInViewFromStart = false) {
  const [isInView, setIsInView] = useState(isInViewFromStart);
  const ref = useRef<HTMLDivElement>(null);

  if (!isClientSideRendering()) {
    return { ref, isInView };
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      {
        rootMargin: "0px 0px -25% 0px",
      },
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return { ref, isInView };
}
